import { render, staticRenderFns } from "./video.vue?vue&type=template&id=57118283&scoped=true"
import script from "./video.vue?vue&type=script&lang=ts"
export * from "./video.vue?vue&type=script&lang=ts"
import style0 from "./video.vue?vue&type=style&index=0&id=57118283&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57118283",
  null
  
)

export default component.exports